/* --------------------------------------------------------------------------------------
   sessionData.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class sessionDataService {
  /*@ngInject*/
  constructor() {}
  setUrlParams(urlParams) {
    const params = new URLSearchParams(window.location.search);
    this.appId = params.get("appId");
    this.deviceId = params.get("deviceId");
    this.serverUrl = params.get("serverUrl");
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/sessionData.service.js